
import { Info } from 'lucide-react';
import { type PowerInfo } from '@/lib/powers-data';
import { renderArticleBlock } from '@/components/help-center/ArticleBodyRender';
import { sanitizeCmsHtml, looksLikeHtml } from '@/lib/cms-html';
import PowerMentionText, { PowerMentionHtml } from '@/components/help-center/powers/PowerMentionText';

interface PowerDetailTutorialProps {
  power: PowerInfo;
}

export default function PowerDetailTutorial({ power }: PowerDetailTutorialProps) {
  const tutorial = power.tutorial;
  const hasTutorial = Boolean(
    tutorial && (tutorial.intro.trim() || tutorial.blocks.length > 0)
  );

  if (!hasTutorial || !tutorial) return null;

  return (
    <section className="border-b border-gray-100 bg-gray-50 py-14">
      <div className="mx-auto max-w-7xl px-6">
        <div className="mb-8 flex items-center gap-3">
          <div className="flex h-9 w-9 items-center justify-center rounded-xl bg-indigo-50">
            <Info className="h-4 w-4 text-indigo-600" />
          </div>
          <div>
            <p className="font-poppins text-xs font-semibold uppercase tracking-widest text-indigo-500">
              Tutorial
            </p>
            <h2 className="font-poppins text-xl font-bold text-gray-900">Como usar</h2>
          </div>
        </div>

        <div className="max-w-3xl">
          {tutorial.intro.trim() ? (
            looksLikeHtml(tutorial.intro) ? (
              <PowerMentionHtml
                html={sanitizeCmsHtml(tutorial.intro)}
                className="mb-8 font-inter text-base leading-relaxed text-gray-600"
              />
            ) : (
              <p className="mb-8 font-inter text-base leading-relaxed text-gray-600">
                <PowerMentionText text={tutorial.intro} as="span" />
              </p>
            )
          ) : null}
          {tutorial.blocks.map((block, idx) => renderArticleBlock(block, idx))}
        </div>
      </div>
    </section>
  );
}
